<template>
  <v-layout align-center justify-center row wrap>
    <v-flex xs12 sm6 md7 v-if="show">
      <h1 class="display-3">Evriday</h1>
      <p class="subheading">Экономьте время для дейсвительно важных задач</p>
    </v-flex>
    <v-flex xs12 sm6 md5>
      <template v-if="!show">
        <h1 class="display-3">Evriday</h1>
        <p class="subheading">Экономьте время для дейсвительно важных задач</p>
      </template>
      <v-card>
        <v-card-title primary-title>
          <div class="headline">Вход в Evriday</div>
        </v-card-title>
        <v-card-text>
          <v-alert class="alert" v-if="errorMessage" color="error" :value="true" >
            {{errorMessage}}
          </v-alert>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field
              v-model="email"
              name="login"
              label="Эл. почта"
              type="text"
              :rules="emailRules"
              outline
              clearable
            ></v-text-field>
            <v-text-field
              v-model="password"
              name="password"
              label="Пароль"
              type="password"
              :rules="emptyFieldRule"
              outline
              clearable
              id="newstyle"
            ></v-text-field>
          </v-form>
          <p><a @click="$emit('changeView', 'ForgotPassword')">Забыли пароль?</a></p>
        </v-card-text>

        <v-card-actions style="padding: 0 16px;">
          <v-btn block large @click="login" color="#4169e1" style="color:white">Войти</v-btn>
        </v-card-actions>

        <v-card-title>
          <p><a href="http://evridayapp.tilda.ws/" target="_blank">Создать новый аккаунт</a></p>
        </v-card-title>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<style scoped>
a:link, a:visited, a:hover, a:active {
  text-decoration: none;
}
#newstyle {
  height: 20px;
  font-size: 20pt;
}
.styled-input label[for] {
  height: 30px;
  font-size: 20pt;
}
</style>
<script>
import axios from 'axios'

export default {
  data () {
    return {
      valid: false,
      email: '',
      password: '',
      emailRules: [],
      emptyFieldRule: [],
      errorMessage: ''
    }
  },
  props: {
    show: Boolean
  },
  watch: {
    email (val) {
      this.emailRules = []
    },
    password (val) {
      this.emptyFieldRule = []
    }
  },
  created () {
    this.$store.commit('hideNavigation')
  },
  methods: {
    login: function () {
      this.emailRules = [
        v => !!v || 'Необходимо заполнить',
        v => /.+@.+/.test(v) || 'Эл. почта должна быть правильной'
      ]
      this.emptyFieldRule = [
        v => !!v || 'Необходимо заполнить'
      ]
      let self = this
      setTimeout(function () {
        if (self.$refs.form.validate()) {
          axios.post('/api/login', {
            email: self.email,
            password: self.password
          })
            .then(response => {
              self.$router.push('/')
            })
            .catch(error => {
              self.errorMessage = error.response.data
            })
        }
      })
    }
  }
}
</script>
